import withLoader from 'components/hoc/withLoader';
import ContentList from './';

export default withLoader(ContentList);
